import DistributionService from '@/services/distribution/';
import ErrorHandler from '@/tools/errorHandler';
import { i18n } from '@/boot/i18n';

export default {
  clearUpdateState({ dispatch }) {
    dispatch('validator/clearValidator', null, { root: true });
  },
  async update({ rootState, dispatch, state }, surveyUUID) {
    try {
      if (rootState.validator.errors.length) {
        return false;
      }
      const payload = {
        uuid: state.distribution.uuid,
        validity_at: state.distribution.validity_at,
        schedule_at: state.distribution.schedule_at,
        survey_uuid: surveyUUID,
      };
      await DistributionService.update(rootState.organization.organization.uuid, payload);
      dispatch('ui/showToastSuccess', i18n.t('distribution.messages.distribution_updated'), { root: true });
      return true;
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
};
